const institutions = state => state.institutions
const institutionsMeta = state => state.institutionsMeta
const groups = state => state.groups
const groupEmployeeSelected = state => state.groupEmployeeSelected
const currentPos = state => state.currentPos

export default {
  institutions,
  institutionsMeta,
  groups,
  groupEmployeeSelected,
  currentPos
}



// WEBPACK FOOTER //
// ./src/store/modules/institution/getters.js